import DonateNowComponent from "@/components/DonateNow/DonateNowComponent";

const DonateNow = () => {
  return <DonateNowComponent />;
};

export default DonateNow;

